
// Task section 23/24/25: semantic relations between DANVA objects - NOT the
// same thing as a geometric coincidence (see suggestRelationsFromTopology()
// below, which only ever SUGGESTS, never creates). Pure data-layer logic;
// the "pick the target in the viewer" interaction itself lives in
// DanvaPanel.js (Level 2/3, genuinely needs the real selection system).
import {findCoincidentEndpointGroups} from "../geometry/topologyQa.js";
import {getDanvaData, DANVA_NAMESPACE} from "./DanvaDomainData.js";

// Adds one relation entry to `feature`'s DANVA relations array via the
// existing setDomainData() mutation path - never a separate relation store.
// `name` is the official DANVA relation name (e.g. "Til") - validated
// against the model's own relation definitions by
// DanvaValidation.validateDanvaObject(), not here (this function only
// records what the user/caller asked for).
export function addRelation(featureManager, feature, {name, targetFeatureId, relationType}){
	const data = getDanvaData(feature);
	if(!data) return;

	const relations = [...data.relations, {name, targetFeatureId, relationType}];
	featureManager.setDomainData(feature.id, DANVA_NAMESPACE, {...data, relations});
}

export function removeRelation(featureManager, feature, {name, targetFeatureId}){
	const data = getDanvaData(feature);
	if(!data) return;

	const relations = data.relations.filter((r) => !(r.name === name && r.targetFeatureId === targetFeatureId));
	featureManager.setDomainData(feature.id, DANVA_NAMESPACE, {...data, relations});
}

// A relation whose target feature has since been deleted is a dangling
// reference (task's own test-category list, section 50: "deleted referenced
// feature") - detected on demand (same on-demand philosophy as
// findCoincidentEndpointGroups() itself - no persistent graph), never
// silently dropped, so the panel can surface it as a data-quality issue
// rather than the relation just quietly vanishing.
export function findDanglingRelations(feature, featureManager){
	const data = getDanvaData(feature);
	if(!data) return [];

	return data.relations.filter((r) => !featureManager.get(r.targetFeatureId));
}

// Task section 25: topology can SUGGEST a relation (an endpoint coincides
// with another DANVA object's geometry), but a geometric coincidence is
// never automatically the same as a semantic DANVA relation - this returns
// candidates for a human to accept/reject, and creates nothing itself.
// Reuses the EXACT SAME on-demand coincident-endpoint detection the
// existing Topology-QA panel and connection-point workflow already use
// (geometry/topologyQa.js findCoincidentEndpointGroups) - not a second
// geometric-adjacency implementation.
export function suggestRelationsFromTopology(feature, allFeatures, {tolerance} = {}){
	const data = getDanvaData(feature);
	if(!data) return [];

	const groups = findCoincidentEndpointGroups(allFeatures, tolerance !== undefined ? {tolerance} : undefined);
	const ownGroup = groups.find((g) => g.members.some((m) => m.featureId === feature.id));
	if(!ownGroup) return [];

	return ownGroup.members
		.filter((m) => m.featureId !== feature.id)
		.map((m) => ({targetFeatureId: m.featureId, targetFeatureName: m.featureName, reason: "coincident-endpoint"}));
}
